import React, { useEffect, useCallback, useState} from 'react';
import Track from 'track/Track.js';
import {connect} from 'react-redux';
import {WIDTH} from '../pianoroll/constants.js';

const ScrolledTick = ({xScale, currentStep, stepsLength}) => { 
    let ratio = currentStep / stepsLength;
    let style = {
        left: ratio * (window.innerWidth - 58 - 240) - 9 
    };
    return (
        <div
          style={style}
          className="piano-scroll-play-tick">
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    if (props.track.pattern.startStep !== undefined) {
        let trackStep = props.sequencerEngine.trackStep - props.track.pattern.startStep;
        return {
            resolution,
            currentStep: trackStep
        };
    }
    var currentStep = 
        props.sequencerEngine.trackStepReal || 0; 
    currentStep = Math.ceil(props.track.getPatternStep(currentStep) /
            (Track.baseResolution.numSteps() /
             state.sequencer.displayResolution.numSteps()));

    return {
        currentStep: currentStep,
        resolution: resolution
    };
};


const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrolledTick);
